export default "__VITE_ASSET__Dyzo1RMP__"